/* SNZ-DRAWER-DOCK 7 Oct 2026 (Z): on phones the bag drawer's footer (gift message,
   delivery + gift-box rows, express pay) filled the screen and pushed the bag itself
   out of view. A grab handle on top of the footer folds everything except Subtotal and
   Checkout; drag it down (or tap) to fold, drag up (or tap) to unfold. The choice is kept
   for the session and survives every drawer re-render (Dawn replaces the drawer HTML on
   each add / quantity change, so this re-mounts through a MutationObserver).
   Styles live in snippets/snz-drawer-perks.liquid. No fixed elements: the cart stays the
   top layer. */
(function () {
  if (window.__snzDock) return;
  window.__snzDock = 1;
  var KEY = 'snz:bagdock';
  // 20 Oct 2026, audit93 H4: also on laptop-height screens (1440x900 showed ~1.5 lines of a
  // 4-line bag under the gift/delivery rows). It still only folds by itself when the items do
  // not fit, and a tap on the handle wins.
  var MQ = window.matchMedia('(max-width: 749px), (max-height: 960px)');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var LBL_MIN = 'Show delivery & gift options';
  var A_MIN = 'Show delivery, gift message and payment options';
  var A_MAX = 'Fold delivery, gift message and payment options to see your bag';

  /* 17 Oct 2026: with no choice saved yet, fold automatically when the bag's
     items do not fit above the footer (the audit found one line's quantity
     stepper cut in half at 390x844, and a second line out of view). Decided
     while the footer is still unfolded, and only ever switches to folded for
     this page view, so it cannot flip back and forth as the drawer re-renders.
     A tap or drag on the handle saves a choice, which always wins. */
  var auto = false;
  function stored() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function fits(f) {
    var d = f.closest('cart-drawer');
    var items = d && d.querySelector('cart-drawer-items');
    if (!items || !items.clientHeight) return true;
    return items.scrollHeight <= items.clientHeight + 4;
  }
  function isMin() { var v = stored(); if (v === '1') return true; if (v === '0') return false; return auto; }
  function save(v) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }

  function fold(el) {
    if (!el || !el.parentNode || el.closest('.snz-fold')) return;
    var w = document.createElement('div');
    var i = document.createElement('div');
    w.className = 'snz-fold';
    el.parentNode.insertBefore(w, el);
    w.appendChild(i);
    i.appendChild(el);
  }

  function apply(f, h, m) {
    f.classList.toggle('snz-dock--min', m);
    h.setAttribute('aria-expanded', m ? 'false' : 'true');
    h.setAttribute('aria-label', m ? A_MIN : A_MAX);
    h.querySelector('.snz-dock__label').textContent = m ? LBL_MIN : '';
  }

  function bind(f, h) {
    var y0 = null, dy = 0, moved = false, id = null;
    function end() {
      if (y0 === null) return;
      f.style.transition = RM.matches ? '' : 'transform .32s cubic-bezier(.32,.72,0,1)';
      f.style.transform = '';
      var m = f.classList.contains('snz-dock--min');
      var next = m;
      if (!moved) next = !m;
      else if (dy > 24) next = true;
      else if (dy < -24) next = false;
      if (next !== m) { apply(f, h, next); save(next); }
      y0 = null; dy = 0;
      try { if (id !== null) h.releasePointerCapture(id); } catch (e) {}
      id = null;
    }
    h.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      y0 = e.clientY; dy = 0; moved = false; id = e.pointerId;
      f.style.transition = 'none';
      try { h.setPointerCapture(id); } catch (err) {}
    });
    h.addEventListener('pointermove', function (e) {
      if (y0 === null) return;
      dy = e.clientY - y0;
      if (Math.abs(dy) > 6) moved = true;
      if (!moved) return;
      var m = f.classList.contains('snz-dock--min');
      /* follow the finger in the direction that changes state, resist the other way */
      var t = m ? (dy < 0 ? dy * 0.5 : dy * 0.15) : (dy > 0 ? dy * 0.5 : dy * 0.15);
      t = Math.max(-48, Math.min(48, t));
      f.style.transform = 'translateY(' + t.toFixed(1) + 'px)';
    });
    h.addEventListener('pointerup', end);
    h.addEventListener('pointercancel', end);
    h.addEventListener('lostpointercapture', end);
    h.addEventListener('click', function (e) { e.preventDefault(); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var next = !f.classList.contains('snz-dock--min');
        apply(f, h, next); save(next);
      }
    });
  }

  function mount() {
    var drawer = document.querySelector('cart-drawer');
    var f = drawer && drawer.querySelector('.drawer__footer');
    if (!f) return;
    var h = f.querySelector(':scope > .snz-dock');
    var on = MQ.matches && !drawer.classList.contains('is-empty');
    if (!on) {
      if (f.classList.contains('snz-dock-on')) f.classList.remove('snz-dock-on');
      if (f.classList.contains('snz-dock--min')) f.classList.remove('snz-dock--min');
      if (h && !h.hidden) h.hidden = true;
      return;
    }
    if (!h) {
      f.classList.add('snz-dock-still');
      Array.prototype.slice.call(f.children).forEach(function (c) {
        if (/^(STYLE|SCRIPT|LINK)$/.test(c.tagName)) return;
        if (c.classList.contains('cart-drawer__footer') || c.classList.contains('cart__ctas')) return;
        fold(c);
      });
      fold(f.querySelector('.cart-drawer__footer .tax-note'));
      fold(f.querySelector('.cart__ctas .snz-drawer-express'));
      fold(f.querySelector('.cart__ctas > a.link'));
      h = document.createElement('button');
      h.type = 'button';
      h.className = 'snz-dock';
      h.innerHTML = '<span class="snz-dock__bar" aria-hidden="true"></span><span class="snz-dock__label"></span>';
      f.insertBefore(h, f.firstChild);
      bind(f, h);
      if (!auto && stored() === null && !fits(f)) auto = true;
      apply(f, h, isMin());
      void f.offsetHeight;
      setTimeout(function () { f.classList.remove('snz-dock-still'); }, 60);
    }
    if (h.hidden) h.hidden = false;
    if (f.classList.contains('snz-dock--min') !== isMin()) apply(f, h, isMin());
    if (!f.classList.contains('snz-dock-on')) f.classList.add('snz-dock-on');
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; mount(); }, 0);
  }

  function start() {
    mount();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      /* the footer is replaced on every re-render; is-empty toggles on the drawer itself */
      new MutationObserver(soon).observe(drawer, { childList: true, subtree: true });
      new MutationObserver(soon).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    if (MQ.addEventListener) MQ.addEventListener('change', soon); else if (MQ.addListener) MQ.addListener(soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
